import {kebabToTitle} from '@/util/string.ts';

export type NameMapperFn = (value: string) => string;
export type NamesObject<T extends Record<string, string>> = Record<T[keyof T], string>;

export function toNamesObject<T extends Record<string, string>>(
	value: T,
	callback: NameMapperFn = kebabToTitle,
): NamesObject<T> {
	const result = {} as NamesObject<T>;

	for (const key in value) {
		const v = value[key];
		result[v] = callback(v);
	}

	return result;
}
